export default __webpack_public_path__ + "static/media/loading-icon.c189c884.svg";